import React from 'react';
import AlgorithmPage from './AlgorithmPage';

const AlgorithmPressedPage = () => {
  return <AlgorithmPage type="pressed" />;
};

export default AlgorithmPressedPage;